import React, { useEffect, useState } from 'react'
import FormProgress from '../components/FormProgress';
import { useTranslation } from 'react-i18next';
import { errorToast } from '../utils/errorHandling';
import { getAnnouncement, getCanvas } from '../services/studentApi';
import { Link } from 'react-router-dom';
import { AiOutlineLoading } from 'react-icons/ai';
import Button from '../components/Button/Button';

const base_url = process.env.REACT_APP_BASE_URL;

const Home = () => {
  const participation_type = localStorage.getItem("participation_type")
    ? JSON.parse(localStorage.getItem("participation_type"))
    : null;
  const courseData = localStorage.getItem("courseData")
    ? JSON.parse(localStorage.getItem("courseData"))
    : null;
  const lang = localStorage.getItem("i18nextLng");

  const [announcement, setAnnouncement] = useState([]);
  const [canvas, setCanvas] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation();

  const fetchAnnouncement = async () => {
    try {
      const res = await getAnnouncement(courseData.id);
      if (res.data) {
        setAnnouncement(res.data);
      }
    } catch (error) {
      throw error;
    }
  };

  const fetchCanvas = async () => {
    try {
      const res = await getCanvas(courseData.id);
      if (res.data) {
        setCanvas(res.data);
      }
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    const init = async () => {
      try {
        fetchAnnouncement();
        fetchCanvas();
      } catch (error) {
        errorToast(error, "Action Failed. Please contact admin", t);
      } finally {
        setIsLoading(false);
      }
    }
    init();
  }, []);


  return (
    <>
      {
        participation_type === "Online" ?
          <div className="welcome-banner">
            <h2>
              {t("Home.WelcomeOnline",
                {
                  course: lang === "en" ?
                    courseData.course_ename
                    :
                    courseData.course_cname
                })}
            </h2>

            <p>
              {t("Home.OnlineDescription",
                {
                  course: lang === "en" ?
                    courseData.course_ename
                    :
                    courseData.course_cname
                })}
            </p>
            <div className='action-buttons'>
              <Link to={`${base_url}/view_attendance`}>
                <Button buttonStyle="btn--primary">{t("Home.CheckAttendance")}</Button>
              </Link>
              <Link to={"https://us02web.zoom.us/j/88972678947?pwd=OyzxsEp6lYEgVVe8AaITYnvN37mrDL.1"} target="_blank" rel="noopener noreferrer">
                <Button buttonStyle="btn--primary">{t("Home.JoinZoom")}</Button>
              </Link>
            </div>
            <div>
              <p className='m-0'>{t("Home.ZoomId")}: <span style={{ color: "#4e73df" }}>889 7267 8947</span></p>
              <p className='m-0'>{t("Home.ZoomPassword")}: <span style={{ color: "#4e73df" }}>999999</span></p>
            </div>
          </div>
          :
          <>
            <h4 className='homepage-title'>{t("Home.FormProgress")}</h4>
            <FormProgress />
          </>
      }
      <h4 className='homepage-title'>{t("Home.Announcement")}</h4>
      <div className='movingCard'>
        <div id="carouselExampleIndicators" className="carousel slide" data-bs-ride="carousel">
          <div className="carousel-indicators">
            {announcement.map((i, index) => (
              <button key={index} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index} className={index === 0 ? "active" : ""} />
            ))}
          </div>
          <div className="carousel-inner">
            {isLoading ?
              <div className='d-flex justify-content-center'>
                <AiOutlineLoading className='spin m-6' />
              </div>
              :
              <>
                {
                  announcement.map((i, index) => (
                    <div className={index === 0 ? "carousel-item active" : "carousel-item"} key={index}>
                      <Link to={i.target_url || ""} target="_blank" rel="noopener noreferrer">
                        <div className="caption">
                          <h5 className='mb-0 mt-3'>☘️ {lang === "en" ? i.title_en : i.title_cn}</h5>
                          <p className='mb-0'> {lang === "en" ? i.description_en : i.description_cn}</p>
                        </div>
                        <img
                          src={i.image_url}
                          className="d-block w-100"
                          alt=""
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = `${base_url}/images/poster.jpg`
                          }}
                        />
                      </Link>
                    </div>
                  ))
                }
              </>
            }
          </div>
          <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
          </button>
          <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
          </button>
        </div>
      </div>
      {
        canvas.map((item, index) => {
          const isEn = lang === "en";

          return (
            <div key={item.id ?? index}>
              <h4 className="homepage-title">
                {isEn ? item.e_title : item.c_title}
              </h4>

              <div className="canvaCard">
                <iframe
                  loading="lazy"
                  className="canva"
                  src={isEn ? item.e_embed_link : item.c_embed_link}
                  allowFullScreen
                />
              </div>

              <div className="canva-link">
                <a
                  href={isEn ? item.e_embed_link : item.c_embed_link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {isEn ? item.e_canva_title : item.c_canva_title}
                </a>
              </div>
            </div>
          );
        })
      }
    </>
  )
}

export default Home